import { styled } from '@mui/material/styles';

export const TabsContainer = styled('div')`
  border-radius: 8px;
  border: 1px solid #ddd;
  width: 624px;
  margin: 0 auto;
  margin-top: 38px;
  position: relative;
  &::-webkit-scrollbar {
    display: none;
  }
  &:hover::-webkit-scrollbar {
    display: block;
  }
`;

export const TabButtons = styled('div')`
  display: flex;
  flex-direction: row;
  position: relative;
  margin-left: 12px;
  z-index: 10;
  border: 1px solid #e8e8e8;
  background: white;
  width: 331px;
  height: 26px;
  position: absolute;
  top: -17px;
  white-space: nowrap;
  font-size: 10px;
  justify-content: space-between;
  padding-left: 10px;
  padding-right: 10px;
`;

export const TabContent = styled('div')`
  padding: 15px;
  background: #fff;
  height: calc(100% - 50px);
  overflow-y: auto;
`;
